import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const RechargeModal = (props) => {
  const { rechargeModal, CloseRechargeModal, handleAmount, goToRechargePaymentOption, AddIntoCart, amount,setAmount } = props;

  const selectedPg = localStorage.getItem("default_Recharge_PgName");
  const paymentMethod =
    selectedPg === "R_CARD"
      ? "CARD"
      : selectedPg === "R_WALLET"
      ? "WALLET"
      : "UPI";

      const handleSetelectAmount=(e,amount)=>{
  //props.setAmount(e.target.value)
  props.setAmount(amount)
}


  return (
    <Dialog
      open={rechargeModal}
      onClose={CloseRechargeModal}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: { xs: "24px 24px 0 0", sm: "16px" },
          position: { xs: "absolute", sm: "relative" },
          bottom: { xs: 0, sm: "auto" },
          m: { xs: 0, sm: "auto" },
          width: { xs: "100%", sm: 400 },
        },
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        {/* Close Button */}
        <Box display="flex" justifyContent="flex-end">
          <CloseIcon
            onClick={CloseRechargeModal}
            sx={{ cursor: "pointer", color: "#718198" }}
          />
        </Box>

        {/* Heading */}
        <Typography
          variant="h6"
          fontWeight={700}
          sx={{ color: "#333F4E", mt: 1 }}
        >
          Select an amount to
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#94A3B8", mt: 0.5, mb: 2 }}
        >
          Recharge RFID Tag
        </Typography>

        {/* Input */}
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Enter Amount"
          value={amount}
          onChange={handleAmount}
          inputProps={{ maxLength: 5 }}
          sx={{
            mt: 2,
            background: "rgba(0, 177, 119, 0.05)",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              fontWeight: 700,
              fontSize: "18px",
              color: "#333F4E",
              borderColor: "rgba(0, 177, 119, 0.70)",
            },
          }}
        />

        {/* Preset Buttons */}
        <Box display="flex" justifyContent="space-between" mt={3}>
          {[50, 100, 200, 500].map((val) => (
            <Button
              key={val}
              variant="outlined"
              onClick={(e) => handleSetelectAmount(e, val)}
              sx={{
                minWidth: "73px",
                height: "38px",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            >
              ₹{val}
            </Button>
          ))}
        </Box>

        {/* Payment Method */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={3}
        >
          <Box>
            <Typography
              sx={{
                color: "#384F6F",
                fontWeight: 600,
                fontSize: "14px",
                letterSpacing: "0.2px",
              }}
            >
              Payment Method
            </Typography>
            <Typography
              sx={{
                color: "#718198",
                fontSize: "14px",
                letterSpacing: "0.2px",
              }}
            >
              {paymentMethod}
            </Typography>
          </Box>
          <Box
            onClick={goToRechargePaymentOption}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Typography sx={{ color: "#718198", fontSize: "13px" }}>
              Change
            </Typography>
            <ArrowForwardIosIcon sx={{ fontSize: 14, ml: 1 }} />
          </Box>
        </Box>

        {/* Proceed Button */}
        <Box display="flex" justifyContent="center" mt={3}>
          <Button
            onClick={AddIntoCart}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#00B177",
              color: "#fff",
              fontWeight: 700,
              textTransform: "uppercase",
              fontSize: "15px",
              borderRadius: "8px",
              py: 1.5,
              "&:hover": {
                backgroundColor: "#019e6b",
              },
            }}
          >
            Proceed To Pay
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RechargeModal;
